<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{ dialogTitle() }}
  </div>
  <button mat-icon-button class="close-btn" (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="form" class="form-grid">
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Rental Type</mat-label>
        <mat-select formControlName="rentalTypeId">
          @for (type of rentalTypes(); track type.id) {
          <mat-option [value]="type.id">{{ type.name }}</mat-option>
          }
        </mat-select>
        @if (form.get('rentalTypeId')?.hasError('required') && form.get('rentalTypeId')?.touched) {
        <mat-error>Rental Type is required</mat-error>
        }
      </mat-form-field>
    </div>
     <div class="form-grid-row">
      <!-- Start Date -->
      <mat-form-field appearance="outline">
        <mat-label>Start Date</mat-label>
        <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" (keydown)="onKeydown($event)">
        <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
        @if (form.get('startDate')?.hasError('required') && form.get('startDate')?.touched) {
        <mat-error>Start Date is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- End Date -->
      <mat-form-field appearance="outline">
        <mat-label>End Date</mat-label>
        <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" (keydown)="onKeydown($event)">
        <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
        @if (form.get('endDate')?.hasError('required') && form.get('endDate')?.touched) {
        <mat-error>End Date is required</mat-error>
        }
      </mat-form-field>

    </div>
    <div class="form-grid-row">
      <!-- Fee -->
      <mat-form-field appearance="outline">
        <mat-label>Fee</mat-label>
        <input matInput type="text" (input)="roundOff($event, 999999, 4, 1, 'fee')" formControlName="fee"
          placeholder="e.g., 100.0000">
        @if (form.get('fee')?.hasError('required') && form.get('fee')?.touched) {
        <mat-error>Fee is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Quantity -->
      <mat-form-field appearance="outline">
        <mat-label>Quantity</mat-label>
        <input matInput type="text" (input)="roundOff($event, 999999, 0, 1, 'quantity')" formControlName="quantity"
          placeholder="e.g., 20.0000">
        @if (form.get('quantity')?.hasError('required') && form.get('quantity')?.touched) {
        <mat-error>Quantity is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <!-- Size -->
      <mat-form-field appearance="outline">
        <mat-label>Size</mat-label>
        <mat-select formControlName="rentalSize">
          @for (s of sizes(); track s.id) {
          <mat-option [value]="s.name">{{ s.name }}</mat-option>
          }
        </mat-select>
        @if (form.get('rentalSize')?.hasError('required') && form.get('rentalSize')?.touched) {
        <mat-error>Size is required</mat-error>
        }
      </mat-form-field>
    </div>
   
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-footer">
  <button mat-raised-button color="primary" (click)="onClose()">
    Cancel
  </button>
  <button mat-raised-button color="primary" (click)="onSave()">
    Save
  </button>
</mat-dialog-actions>